<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-text-field
          id="taxCommentCommentCode"
          class="tax-fund-edit-dialog-fund-number-text"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model.number="editedItem.feeNumber"
          label="Fee Number"
          @blur="somethingChanged"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          id="taxCommentComments"
          class="tax-fund-edit-dialog-default-mills-text"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.feeDescription"
          label="Fee Description"
          @blur="somethingChanged"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          id="taxCommentComments"
          class="tax-fund-edit-dialog-default-mills-text"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.toUnit"
          label="To Unit"
          @blur="somethingChanged"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'taxFeeEditItem',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxFeeTypes',
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'index', 'isVisible']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
  },
};
</script>
